import { IApiResponse } from "../interfaces/IApiResponse";

export class ApiResponse implements IApiResponse {
    isSuccessful: boolean = false;
    resultCode?: string = '';
    value?: any = null;
    logMessages?: string[] = [];
    errors?: string[] = [];

    constructor(config: IApiResponse) {
        this.isSuccessful = config.isSuccessful;
        if (config.resultCode != undefined)
            this.resultCode = config.resultCode;
        if (config.value != undefined)
            this.value = config.value;
        if (config.logMessages != undefined)
            this.logMessages = config.logMessages;
        if (config.errors != undefined)
            this.errors = config.errors;
    }

    // at this point we're not taking advantage of multiple error messages, so this is a helper method to get
    // the only error message. If we support multiple errors in the future, we should do this differently 
    // (at the very least rename this to getFirstErrorMessage() or something like that).
    getErrorMessage(): string {
        if (!this.isSuccessful)
            return (this.errors.length > 0) ? this.errors[0] : this.resultCode;
        return '';
    }
}
